<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="读数列表">
        <div>
          <div style="margin-bottom: 10px;">
            <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
              <el-descriptions-item label="仪表编号">
                <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable @change="pageChange(1)"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="当前房产">
                <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="仪表名称">
                <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="仪表类型">
                <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan" @change="pageChange(1)">
                  <el-option
                    v-for="item in meter_type_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="仪表性质">
                <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
                  <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
              <el-descriptions-item label="能耗类型">
                <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
                  <el-checkbox v-for="(item,index) in energy_list" :label="item.val" :key="index">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="exportExcel">导出明细</el-button>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>总金额：</span>
            <span style="color: #ff3d00;font-weight: bold;">{{pageData.all_money}}</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>当前页总金额：</span>
            <span style="color: #ff3d00;font-weight: bold;">{{pageData.page_money}}</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span>注：如果本期读数与上期（上年同期）读数相差50%或以上,会出现涨幅数据，便于审核。</span>
          </div>
          <el-table v-if="pageData" v-loading="loading" border width="100%" height="calc( 100vh - 150px )" :data="pageData.list" @selection-change="handleSelectionChange">
            <el-table-column prop="id" label="id"  width="50" fixed></el-table-column>
            <el-table-column prop="number" label="仪表编号 " width="100" fixed></el-table-column>
            <el-table-column prop="house_name" label="所在房产" width="320"></el-table-column>
            <el-table-column prop="name" label="仪表名称 " width="100"></el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型"  width="100"></el-table-column>
            <el-table-column prop="charging_standard_name" label="收费标准 " width="250"></el-table-column>
            <el-table-column prop="charging_standard_money" label="单价 " width="100">
              <template slot-scope="scope">
                <span style="font-weight: bold;color: #000000;">{{scope.row.charging_standard_money}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="dosage_number" label="本期用量" width="100" >
              <template slot-scope="scope">
                <span style="font-weight: bold;color: #000000;">{{scope.row.dosage_number}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="本期金额" width="100">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="computeAmount(scope.row)" placement="bottom">
                  <el-link>
                    <span style="font-weight: bold;color: #000000;">{{scope.row.amount}}</span>
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="read_number" label="本期读数" width="100"></el-table-column>

            <el-table-column prop="read_time" label="抄表日期" width="100"></el-table-column>
            <el-table-column prop="last_year_dosage_number" label="去年同期用量" width="140">
              <template slot-scope="scope">
                <span>{{scope.row.last_year_dosage_number}}</span>
                <span style="color: #ff1818;" v-if="scope.row.tong_bi>(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↑</span>
                <span style="color: #3b6ed9;" v-if="scope.row.tong_bi<-(scope.row.last_year_dosage_number/2)">{{scope.row.tong_bi}} ↓</span>
              </template>
            </el-table-column>
            <el-table-column prop="last_dosage_number" label="上期用量" width="140">
              <template slot-scope="scope">
                <span>{{scope.row.last_dosage_number}}</span>
                <span style="color: #ff1818;" v-if="scope.row.huan_bi>(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↑</span>
                <span style="color: #3b6ed9;" v-if="scope.row.huan_bi<-(scope.row.last_dosage_number/2)">{{scope.row.huan_bi}} ↓</span>
              </template>
            </el-table-column>
            <el-table-column prop="mn_admin_name" label="抄表人" width="100"></el-table-column>
            <el-table-column prop="is_examine" label="审核" width="100">
              <template slot-scope="scope">
                {{scope.row.is_examine?'已审':'未审'}}
              </template>
            </el-table-column>
            <el-table-column prop="mn_files" label="图片" width="100">
              <template slot-scope="scope">
                <el-popover v-if="scope.row.mn_files.length>0"
                            placement="right"
                            width="500"
                            trigger="hover">
                  <div>
                    <el-carousel indicator-position="outside">
                      <el-carousel-item v-for="(item,index) in scope.row.mn_files" :key="index">
                        <el-image fit="scale-down" style="width: 480px; " :src="item"></el-image>
                      </el-carousel-item>
                    </el-carousel>

                  </div>
                  <el-image slot="reference" v-for="(item,index) in scope.row.mn_files" :key="index"
                            style="width: 80px; height: 80px"
                            :src="scope.row.mn_files[0]"
                            fit="cover"></el-image>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="mn_remarks" label="备注" width="100"></el-table-column>
            <el-table-column label="操作 " width="180">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="showAnalysis(scope.row)">能耗分析</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
        </div>
      </el-tab-pane>
      <el-tab-pane label="抄表费用" v-if="master_id==43">
        <MeterList v-if="master_id==43" :batch_number2="batch_number" :master_id2="master_id" :task_id2="task_id" :meter_temp_money="pageData.all_money"  @submitMeter="submitMeter" />
      </el-tab-pane>
      <el-tab-pane label="分摊明细" v-if="master_id==41" >
        <MeterShareList v-if="master_id==41" :batch_number2="batch_number" :master_id2="master_id" :task_id2="task_id" :meter_temp_money="pageData.all_money" @submitMeter="submitMeter" />
      </el-tab-pane>
      <el-tab-pane label="抄表调整" :disabled="isDisabled">
        <MeterNoteWriteFlow v-if="!isDisabled" :batch_number="batch_number" :user_type="master_id==43?1:2" @submitMeter="submitMeter" />
      </el-tab-pane>
<!--      <el-tab-pane label="抄表导入" :disabled="isDisabled">-->
<!--        <MeterNoteExcelFlow v-if="!isDisabled" :batch_number="batch_number" @submitMeter="submitMeter" />-->
<!--      </el-tab-pane>-->
    </el-tabs>

    <MeterNoteAnalysisWindow ref="MeterNoteAnalysisWindow" />
  </div>
</template>

<script>
import ImportMeter from "./components/ImportMeter";
import MeterNoteWriteFlow from "./MeterNoteWriteFlow";
import MeterNoteExcelFlow from "./MeterNoteExcelFlow";
import MeterList from "./order/MeterList";
import MeterShareList from "./order/MeterShareList";
import AppConfig from "../../../config/AppConfig";
import MeterNoteAnalysisWindow from "../EnergyConsumption/components/meter_note/components/MeterNoteAnalysisWindow";
import moment from "moment";
export default {
  name: "MeterNoteViewCache",
  components: {MeterNoteAnalysisWindow, MeterShareList, MeterList, MeterNoteExcelFlow, MeterNoteWriteFlow, ImportMeter},
  props:{
    batch_number2:{
      type:String|Number,
      default(){
        return''
      }
    },
    task_id2:{
      type:String|Number,
      default(){
        return''
      }
    },
    master_id2:{
      type:String|Number,
      default(){
        return''
      }
    },
  },
  data(){
    return{
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        energy_ids:[1,2,3],
        is_freezes:[0,1],
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
        all_money:0,
        page_money:0
      },
      loading:false,
      batch_number:'',
      task_id:0,
      multipleSelection:[],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      isDisabled:true,
      master_id:0,
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
    }
  },
  created() {
    this.batch_number=this.$route.query.batch_number||this.batch_number2;
    this.task_id=(this.$route.query.task_id?(this.$route.query.task_id)*1:0)||this.task_id2;
    this.master_id=this.$route.query.master_id||this.master_id2;
  },
  mounted() {
    this.getMeterTypeList()
    this.getList()
    this.getFlowData()
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,name,expenditure_id,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getList() {
      const that = this;
      that.loading = true;
      let where=reObject(that.where)
      ERP.postRequest({
        url: "admin/MeterNote/getBatchNumberMeterNoteList",
        data: {
          where:JSON.stringify(where),
          batch_number:that.batch_number,
          task_id:that.task_id,
          page: that.pageData.page,
          page_size: that.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          res.data.list=res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            ret.mn_files=that.readImages(ret.mn_files)
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    meterImport(batch_number){
      this.batch_number=batch_number;
      this.excel_list2=[];
      this.getList();
    },
    computeAmount(item){
      return ` ( ${item.read_number} - ${item.last_read_number} ) * ${item.charging_standard_money}= ${item.amount}`
    },
    readImages(mn_files){
      if(mn_files){
        let images=mn_files.split(',');
        return images.map(url=>{
          return loadUrl(url);
        })
      }else {
        return [];
      }
    },
    submitMeter(e){
      this.getList();
    },
    getFlowData(){
      const that=this;
      if(!that.task_id){
        that.isDisabled=false;
      }
      that.task_id&&ERP.postRequest({
        url:"admin/Meter/getFlowData",
        data:{
          task_id:that.task_id,
        },
      },ret=>{
        if(ret.code){
          // that.excel_list2=ret.data;
          this.flowData=ret.data
          console.log([11,10].includes(ret.data.status*1),ret.data.status)
          if([11,10].includes(ret.data.status*1)){
            that.isDisabled=false;
          }
        }else {
          this.$message.error(ret.msg||'数据异常')
        }
      })
    },
    exportExcel(){
      const that=this;
      ERP.postRequest({
        url:"admin/MeterNote/getFlowExcelList",
        data:{
          batch_number:that.batch_number,
        },
      },ret=>{
        if(ret.code){
          window.open(AppConfig.erp_server+ret.data)
        }else {
          this.$message.error(ret.msg||'数据异常')
        }
      })
    },
    showAnalysis(item){
      this.$refs.MeterNoteAnalysisWindow.show(item.id,item.number+"_"+item.name)
    },

  },
  watch: {
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
  },
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
function loadUrl(url){
  return "http://engineering.gdzawy.com:9000/admin/public"+url;
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterNoteViewCache.vue